/**
 * Portal Message Badge
 * Small red circle badge showing unread count
 */

interface PortalMessageBadgeProps {
  count: number
}

export function PortalMessageBadge({ count }: PortalMessageBadgeProps) {
  if (count <= 0) return null

  return (
    <span
      style={{
        position: 'absolute',
        top: '-4px',
        right: '-8px',
        background: 'var(--color-danger, #dc2626)',
        color: 'white',
        fontSize: '0.75rem',
        fontWeight: 600,
        borderRadius: '9999px',
        minWidth: '18px',
        height: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 5px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
      }}
    >
      {count > 99 ? '99+' : count}
    </span>
  )
}
